import React from 'react';
import HeroFirstItem from './HeroFirstItem';
import Brief from './Brief';
import Canvas from '../art/Canvas';

const sectionContent =
  {
    tagline: "",
    type: "About me",
    role: "Product/UX designer ",
    slogan: "Hi there! I'm Jinju – a product / UX designer based in Melbourne.",
    leadParagraph: "From discovery research, wireframes, to interactive prototypes... I've been designing for iOS, Android, and Web platforms in the last 8 years. My mission is to delight people with the beauty of well-designed, kind user experience.",
    nextPage: "More about me",
    pageUrl: "/about"
  };

const IntroductionFirstItem = ({tagline, type, slogan, leadParagraph, nextPage}) => (
  <section>
    <div>
      <Canvas/>
      <Brief
        year={sectionContent.type}
        role={sectionContent.role}
        company={sectionContent.slogan}
        leadParagraph={sectionContent.leadParagraph}
        pageUrl={sectionContent.pageUrl}
        nextPage={sectionContent.nextPage}
      />
    </div>
  </section>
);

export default IntroductionFirstItem;



// WEBPACK FOOTER //
// ./src/layout/hero/IntroductionFirstItem.js